var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SubMenuInline from './sub-menu-inline';
import SubMenuPop from './sub-menu-pop';
var SubMenu = /** @class */ (function (_super) {
    __extends(SubMenu, _super);
    function SubMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var _a = _this.props, getOpenKeys = _a.getOpenKeys, _key = _a._key;
            getOpenKeys && getOpenKeys(_key);
        };
        _this.onClickSubMenu = function () {
            var _a = _this.props, _key = _a._key, onClickSubMenu = _a.onClickSubMenu, level = _a.level;
            onClickSubMenu && onClickSubMenu(_key, level);
        };
        return _this;
    }
    SubMenu.prototype.render = function () {
        var _a = this.props, mode = _a.mode, collapse = _a.collapse, children = _a.children;
        if (mode === 'vertical' && !collapse) {
            return React.createElement(SubMenuInline, __assign({}, this.props), children);
        }
        return React.createElement(SubMenuPop, __assign({}, this.props), children);
    };
    SubMenu.propTypes = {
        style: PropTypes.object,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    };
    SubMenu.menuType = 'SubMenu';
    SubMenu.defaultProps = {
        hide: false,
        style: {},
        selectable: false,
    };
    return SubMenu;
}(Component));
export default SubMenu;
